import axiosService from '@/api/common/adminAxios'

const api = {
  selectAdminMenuList: function(paramData) {
    return axiosService.post('menuAdmin/selectAdminMenuList', paramData)
  },

  selectAdminAuthMenuList: function(paramData) {
    return axiosService.post('menuAdmin/selectAdminAuthMenuList', paramData)
  },
}

export default api
